import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { startNoOpTenderOrder, closeTabNoOpTender } from '../actions/order'
import { makeGetNoOpTenders } from '../selectors/revenueCenter'
import SelectNoOpPayment from '../components/SelectNoOpPayment'

const getRedirect = (modalType, orderId) =>{
  if (orderId) {
    return `/tabs/${orderId}`
  } else if (modalType === 'start-tab') {
    return '/tab-order'
  } else if (modalType === 'pay-now') {
    return '/tab-order/pay-now'
  } else {
    return '/tabs'
  }
}

const mapStateToProps = (state) => {
  const noOpTenders = makeGetNoOpTenders()(state)

  return {
    noOpTenders,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const orderId = props?.match?.params?.orderId
  const modalType = props?.match?.params?.modalType
  const exemptionOverrides = props?.history?.location?.state?.exemptionOverrides ?? {}
  const userNotes = props?.history?.location?.state?.userNotes ?? null
  const replace = props?.history?.replace ?? (() => {})
  const deferClose = props?.history?.location?.state?.deferClose ?? false

  return {
    onClose: () => {
      const redirect = getRedirect(modalType, orderId)
      replace(redirect)
    },
    startNoOpTenderOrder: (tender) => {
      if (orderId) {
        const payload = {
          tender,
          orderId,
          deferClose,
        }
        dispatch(closeTabNoOpTender(payload))
      } else {
        const payload = {
          tender,
          exemptionOverrides,
          userNotes,
          state: modalType === 'start-tab' ? 'tabbed' : undefined,
        }
        dispatch(startNoOpTenderOrder(payload))
      }
    },
    routeToChangeCalculator: () => replace('/change-calculator'),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectNoOpPayment))
